import { useState, useRef, useEffect } from 'react';
import CloseIcon from '../../../assets/icons/close.svg?react';
import StationAddressModal from './StationAddressModal';
import { useCreateStation } from '../../../hooks/queries/stationQueries';
import { useNavermaps } from "react-naver-maps";
import {
  Container as MapDiv,
  NaverMap,
  Marker,
  useListener,
} from "react-naver-maps";

const StationAppendSideModal = ({onClose, onSuccess}) => {
  // useNavermaps 훅 사용
  const navermaps = useNavermaps();

  const [stationAppendObject, setStationAppendObject] = useState({
    powerMeterContractNumber: null,
    cpoStationId: null,
    cpoStationName: null,
    cpoName: null,
    cpoId: null,
    address: null,
    lat: null,
    lng: null
  });

  // 지도 관련 상태
  let [map, setMap] = useState();
  const [pos, setPos] = useState(null);
  const [reg, setReg] = useState(null);
  const handleStationAppendObject = (e) => {
    setStationAppendObject({ ...stationAppendObject, [e.target.id]: e.target.value });
  }

  const [addressModalOn, setAddressModalOn] = useState(false);

  // React Query mutation 훅을 컴포넌트 최상위 레벨에서 호출
  const createStationMutation = useCreateStation();

  const onComplete = (data) => {
    
    // 더 상세한 주소 정보 사용
    const address = data.roadAddress || data.address;
    
    setStationAppendObject(prev => ({ 
      ...prev, 
      address: address 
    }));
    setAddressModalOn(false);
    
    // 지도가 초기화되었는지 확인
    if (map) {
      // 지도가 이미 초기화되어 있으면 바로 좌표 변환 실행
      searchAddressToCoordinate(address);
    } else {
      // 지도가 아직 초기화되지 않았으면 대기
      setPendingAddress(address);
    }
  }

  // 헬퍼 함수들
  function hasArea(area) {
    return !!(area && area.name && area.name !== "");
  }

  function hasData(data) {
    return !!(data && data !== "");
  }

  function checkLastString(word, lastString) {
    return new RegExp(lastString + "$").test(word);
  }

  function hasAddition(addition) {
    return !!(addition && addition.value);
  }

  function makeAddress(item) {
    if (!item) {
      return;
    }

    var name = item.name,
      region = item.region,
      land = item.land,
      isRoadAddress = name === "roadaddr";
    var sido = "",
      sigugun = "",
      dongmyun = "",
      ri = "",
      rest = "";

    if (hasArea(region.area1)) {
      sido = region.area1.name;
    }
    if (hasArea(region.area2)) {
      sigugun = region.area2.name;
    }
    if (hasArea(region.area3)) {
      dongmyun = region.area3.name;
    }
    if (hasArea(region.area4)) {
      ri = region.area4.name;
    }
    if (land) {
      if (hasData(land.number1)) {
        if (hasData(land.type) && land.type === "2") {
          rest += "산";
        }
        rest += land.number1;
        if (hasData(land.number2)) {
          rest += "-" + land.number2;
        }
      }
      if (isRoadAddress === true) {
        if (checkLastString(dongmyun, "면")) {
          ri = land.name;
        } else {
          dongmyun = land.name;
          ri = "";
        }
        if (hasAddition(land.addition0)) {
          rest += " " + land.addition0.value;
        }
      }
    }
    return [sido, sigugun, dongmyun, ri, rest].join(" ");
  }

  // 지도 초기화 후 좌표 변환을 위한 상태
  const [pendingAddress, setPendingAddress] = useState(null);

  // 지도가 초기화되면 대기 중인 주소로 좌표 변환 실행
  useEffect(() => {
    if (map && pendingAddress) {
      searchAddressToCoordinate(pendingAddress);
      setPendingAddress(null);
    }
  }, [map, pendingAddress]);

  function searchAddressToCoordinate(address) {
    if (address == "") {
      console.warn('주소가 비어있습니다.');
      return;
    }
    
    
    navermaps.Service.geocode(
      {
        query: address,
      },
      function (status, response) {
        
        if (status === navermaps.Service.Status.ERROR) {
          alert("주소를 좌표로 변환하는데 실패했습니다. 다시 시도해주세요.");
          return;
        }
        
        if (!response.v2.addresses || response.v2.addresses.length === 0) {
          alert("해당 주소에 대한 좌표를 찾을 수 없습니다. 다른 주소를 시도해주세요.");
          return;
        }
        
        var item = response.v2.addresses[0],
          point = new navermaps.LatLng(item.y, item.x);
        
        
        // 상태 업데이트
        setStationAppendObject(prev => ({ 
          ...prev, 
          lat: point.lat, 
          lng: point.lng 
        }));
        setPos(point);
        
        // 지도 중심점 이동
        if (map) {
          map.setCenter(point);
        }
      }
    );
  }

  const changeCenter = (e) => {
    setPos(new navermaps.LatLng(e.y, e.x));
    setStationAppendObject(prev => ({ 
      ...prev, 
      lat: e.y, 
      lng: e.x 
    }));
    navermaps.Service.reverseGeocode(
      {
        coords: new navermaps.LatLng(e.y, e.x),
        orders: [navermaps.Service.OrderType.ROAD_ADDR].join(","),
      },
      function (status, response) {
        if (status !== navermaps.Service.Status.OK) {
          return alert("Something wrong!");
        }
        var items = response.v2.results,
          address = "",
          region = "",
          htmlAddresses = [];

        let item = items[0];
        address = makeAddress(item) || "";
        region = item?.region.area1.alias;
        htmlAddresses.push(address);
        if (htmlAddresses == "") return;
        setStationAppendObject(prev => ({ 
          ...prev, 
          address: htmlAddresses[0]
        }));
        setReg(regionConvert(region));
      }
    );
  };

  const handleStationAppend = async () => {
    if(!stationAppendObject.cpoStationId || !stationAppendObject.address || !stationAppendObject.powerMeterContractNumber){
      alert('필수 항목을 입력해주세요.');
      return;
    }
    
    try {
      await createStationMutation.mutateAsync(stationAppendObject);
      onSuccess(); // 추가 성공 시 콜백 호출
      onClose();
    } catch (error) {
      console.error('충전소 추가 실패:', error);
      alert('충전소 추가에 실패했습니다.');
    }
  };
  
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>충전소 추가</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>  
              <td>
                <label htmlFor="cpoStationId" className='w-20 mr-10 text-b2-700 text-gray-700 required'>충전소 식별자</label>
              </td>
              <td>
                <input value={stationAppendObject.cpoStationId} type="text" id="cpoStationId" className='w-full input-primary' placeholder='충전소 식별자를 입력해주세요.' onChange={handleStationAppendObject} autoComplete='off'/>
              </td>
            </tr> 
            <tr>    
              <td>
                <label htmlFor="cpoStationName" className='w-20 mr-10 text-b2-700 text-gray-700'>충전소 이름</label>
              </td>
              <td>
                <input value={stationAppendObject.cpoStationName} type="text" id="cpoStationName" className='w-full input-primary' placeholder='충전소 이름을 입력해주세요.' onChange={handleStationAppendObject} autoComplete='off'/>
              </td>
            </tr> 
            <tr>
              <td>
                <label htmlFor="address" className='w-20 mr-10 text-b2-700 text-gray-700 required'>충전소 주소</label>
              </td>
              <td>
                <input value={stationAppendObject.address} type="text" id="address" className='w-full input-primary' placeholder='충전소 주소를 입력해주세요.' onChange={handleStationAppendObject} readOnly autoComplete='off'/>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <div className='flex justify-end'>
                  <button className='btn big-btn btn-primary' onClick={() => setAddressModalOn(true)}>주소 검색</button>
                </div>
              </td>
            </tr>
            {/* 지도 및 좌표 정보 */}
            <tr>
              <td colSpan="2">
                <div className="mt-4">
                  <div className='bg-gray-700 flex align-center justify-center text-c2-400 text-gray-200 py-3'>지도를 움직여 정확한 위치를 설정하세요</div>
                  <div className="border rounded-lg overflow-hidden" style={{ height: '300px' }}>
                    <MapDiv
                      className="w-full h-full"
                      error={<p className="p-4 text-center">지도 로드 오류</p>}
                      loading={<p className="p-4 text-center">지도 로딩 중...</p>}
                    >
                      <NaverMap
                        ref={setMap}
                        defaultCenter={pos || new navermaps.LatLng(33.4889293, 126.4984207)}
                        defaultZoom={17}
                        disableKineticPan={false}
                        scaleControl={true}
                        onCenterChanged={(e) => {
                          changeCenter(e);
                        }}
                        onBoundsChanged={(e) => {}}
                        minZoom={9}
                        maxZoom={21}
                      >
                        {pos && (
                          <Marker
                            position={pos}
                            icon={{
                              content: `<div style="background-color: #007bff; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white;"></div>`,
                              size: new navermaps.Size(20, 20),
                              anchor: new navermaps.Point(10, 10),
                            }}
                          />
                        )}
                      </NaverMap>
                    </MapDiv>
                  </div>
                  <div className='grid grid-cols-2 mt-4'>
                    <div className='flex align-center gap-10'>
                      <label className='text-b3-700 text-gray-700'>위도</label>
                      <p className='text-b3-400 text-gray-600'>{stationAppendObject.lat}</p>
                    </div>
                    <div className='flex align-center gap-10'>
                      <label className='text-b3-700 text-gray-700'>경도</label>
                      <p className='text-b3-400 text-gray-600'>{stationAppendObject.lng}</p>
                    </div>

                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="cpoName" className='w-20 mr-10 text-b2-700 text-gray-700'>충전사업자</label>
              </td>
              <td>
                <input value={stationAppendObject.cpoName} type="text" id="cpoName" className='w-full input-primary' placeholder='충전사업자를 입력해주세요.' onChange={handleStationAppendObject} autoComplete='off'/>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="cpoId" className='w-20 mr-10 text-b2-700 text-gray-700'>충전사업자 식별자</label>
              </td>
              <td>
                <input value={stationAppendObject.cpoId} type="text" id="cpoId" className='w-full input-primary' placeholder='충전사업자 식별자를 입력해주세요.' onChange={handleStationAppendObject} autoComplete='off'/>
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="powerMeterContractNumber" className='w-20 mr-10 text-b2-700 text-gray-700 required'>계량기 계약번호</label>
              </td>
              <td>
                <input value={stationAppendObject.powerMeterContractNumber} type="text" id="powerMeterContractNumber" className='w-full input-primary' placeholder='계량기 계약번호를 입력해주세요.' onChange={handleStationAppendObject} autoComplete='off'/>
              </td>
            </tr>
          </table>
          <div className='flex justify-end w-full'>
            <button 
              className='btn big-btn btn-primary flex-1' 
              onClick={handleStationAppend}
              disabled={createStationMutation.isPending}
            >
              {createStationMutation.isPending ? '등록 중...' : '등록하기'}
            </button>
          </div>
        </div>
        {
          addressModalOn && (
            <StationAddressModal onClose={() => setAddressModalOn(false)} onComplete={onComplete} />
          )
        }
      </div>
    </div>
  )
}

export default StationAppendSideModal